import React, { Component } from 'react';
import ReactGA from 'react-ga';
import { Navigation, Section } from './components';
import { navItems } from './config/nav';
import { Wrapper, Content, Tagline, Footer } from './components/general';
import { About, Services, Design, Portfolio, Home, Contact } from './config/content';
import './App.css';
import './fonts/fa/css/font-awesome.min.css';

class App extends Component {

  componentDidMount() {
    ReactGA.initialize('UA-83966920-3');
    ReactGA.pageview('/');
  }
  render() {
    return (
      <Wrapper>
        <Navigation
          items={navItems}
        />
        <Content>
        <a className="anchor" name="home" />
          <Tagline>
            {Home}
          </Tagline>
          <Section
            anchor="about"
            title="About"
            content={About}
          />
          <Section
            anchor="services"
            title="Services"
            content={Services}
          />
          <Section
            anchor="design"
            title="Design"
            content={Design}
          />
          <Section
            anchor="portfolio"
            title="Portfolio"
            content={Portfolio}
          />
          <Section
            anchor="contact"
            title="Contact"
            content={Contact}
          />
          <Footer>
            <span className="left">© Vital 38 Media LLC 2017</span>
            <span className="center"></span>
            <span className="right"><a href="mailto:projects@vital38.com">projects@vital38.com</a></span>
          </Footer>
        </Content>
      </Wrapper>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js